






export default
  props: [ 'color', 'will_flip' ]
